// 文件传输后台管理 API

import { getApiBase } from "./fileTransferToken";
import { getAdminToken } from "./adminAuth";

function getBase() {
  const base = getApiBase();
  if (!base) throw new Error("API not configured");
  return base;
}

function authHeaders() {
  const token = getAdminToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

// 创建传输会话
export async function createTransfer({ title, description, expiry, maxFileSize, maxFiles }) {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfer/create`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ title, description, expiry, maxFileSize, maxFiles }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "CREATE_FAILED");
    err.status = res.status;
    throw err;
  }
  return res.json();
}

// 列出所有传输会话
export async function listTransfers() {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfers`, {
    headers: { Authorization: `Bearer ${getAdminToken()}` },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "LIST_FAILED");
    err.status = res.status;
    throw err;
  }
  const body = await res.json();
  return body.sessions || [];
}

// 更新传输会话
export async function updateTransfer(id, updates) {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfer/${encodeURIComponent(id)}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(updates),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "UPDATE_FAILED");
    err.status = res.status;
    throw err;
  }
  return res.json();
}

// 删除传输会话
export async function deleteTransfer(id) {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfer/${encodeURIComponent(id)}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${getAdminToken()}` },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "DELETE_FAILED");
    err.status = res.status;
    throw err;
  }
  return true;
}

// 删除传输会话中的单个文件
export async function deleteTransferFile(transferId, fileId) {
  const base = getBase();
  const res = await fetch(`${base}/api/file-transfer/${encodeURIComponent(transferId)}/files/${encodeURIComponent(fileId)}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${getAdminToken()}` },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error?.message || "DELETE_FILE_FAILED");
    err.status = res.status;
    throw err;
  }
  return true;
}
